import { Component } from '@angular/core';

@Component({
    selector: 'upsell-lock',
    templateUrl: './upsell-lock.component.html',
    styleUrls: ['./upsell-lock.component.scss'],
    
})
export class UpsellLockComponent {}
